module.exports = __webpack_public_path__ + "img/join_black.51b2f44a.png";